"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Unlocked;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Unlocked(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "unlocked"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M77.518,40.247H22.482a3.5,3.5,0,0,0-3.5,3.5V89a3.5,3.5,0,0,0,3.5,3.5H77.518a3.5,3.5,0,0,0,3.5-3.5V43.747A3.5,3.5,0,0,0,77.518,40.247ZM76.018,87.5H23.982V45.247H76.018Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.658,35.749a2.5,2.5,0,0,0,2.5-2.5V28.342a15.819,15.819,0,0,1,26.589-11.61,2.5,2.5,0,0,0,3.4-3.667A20.819,20.819,0,0,0,29.158,28.342v4.907A2.5,2.5,0,0,0,31.658,35.749Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.5,71.752v5.984a2.5,2.5,0,0,0,5,0V71.752a9.765,9.765,0,1,0-5,0ZM50,57.559a4.765,4.765,0,1,1-4.765,4.765A4.771,4.771,0,0,1,50,57.559Z"
  })))));
}